module.exports = __webpack_public_path__ + "img/tel.c9352a73.png";